<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Create Role </h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Name *</label>
                  <div class="col-md-10">
                    <input
                      id="name"
                      v-model="entity.name"
                      type="text"
                      placeholder="Enter name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Permissions</label>
                  <div v-if="defaultOptionsLoaders.permissions" class="col-md-10 spinner-parent">
                    <spinner ref="spinner" size="md" text="Loading ..." style="display: block;" />
                  </div>
                  <div v-else class="col-md-10">
                    <div class="mb-10">
                      <button class="btn btn-primary" @click="selectAll">Select all</button>
                      <button class="btn btn-primary" @click="deselectAll">Deselect all</button>
                    </div>
                    <div style="column-count: 3;">
                      <div v-for="permission in defaultOptions.permissions" :key="permission.id">
                        <label>
                          <input
                            :id="permission.id"
                            v-model="entity.permissions"
                            type="checkbox"
                            :value="permission"
                          > {{ permission.name }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Role has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';

export default {
  name: 'RolesNew',

  mixins: [CreatePageMixin, DefaultOptionsRequests],

  data() {
    return {
      entity: {
        name: null,
        permissions: [],
      },
    };
  },

  mounted() {
    this.$_getDefaultPermissions();
  },

  methods: {
    selectAll() {
      this.entity.permissions = [...this.defaultOptions.permissions];
    },
    deselectAll() {
      this.entity.permissions = [];
    },
    isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      return true;
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      if (this.entity.permissions && this.entity.permissions.length) {
        for (let i = 0; i < this.entity.permissions.length; i += 1) {
          postFormData.append('permissions[]', this.entity.permissions[i].id);
        }
      }
      return this.$apiHttp.post(`${this.$config.app_api.prefix}roles`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest()
        .then((response) => {
          this.$_successSave();
          this.$parent.getSource();
          window.location.hash = `#/admin/roles/edit/${response.data.id}`;
        }).catch((error) => {
          console.error('Error in role create query', error);
          this.$_errorSave(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?1b40cc54